import { useQuery } from "@tanstack/react-query";
import { getOwnershipAccountability } from "./api";

// currentPeriod lives in ownershipFormat (pure, no react-query) so the verdict/summary can use it
// too; re-exported here for the page's existing import path.
import { currentPeriod } from "./ownershipFormat";

export { currentPeriod };

// useOwnershipAccountability loads the dashboard payload (Organisation lens only). Coverage is
// measured server-side over a rolling last-30d window, so there's no period parameter — the query
// is keyed by a fixed window id (the daily data epoch advances the window).
export function useOwnershipAccountability() {
  return useQuery({
    queryKey: ["ownership-accountability", "last-30d"],
    queryFn: () => getOwnershipAccountability(),
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
    refetchOnMount: "always",
  });
}
